"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M12.739 13.73h-1.7v-1.447l1.307-.893c.589-.403.955-.68.955-1.335 0-.604-.432-1.07-1.23-1.07-.927 0-1.45.592-1.45 1.498H9C9 8.557 10.346 7.5 12.085 7.5 14.045 7.5 15 8.721 15 10.018c0 1.356-.998 2-1.786 2.51l-.07.045-.405.264v.894zm0 2.77h-1.7v-1.636h1.7V16.5z" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zm10 8.5a8.5 8.5 0 110-17 8.5 8.5 0 010 17z" })), "GuidelineOutline");
//# sourceMappingURL=GuidelineOutline.js.map